export const LisaEvents = {};

LisaEvents.hasActiveEvent = () => {
  return LisaEvents.packageTask() ||
    LisaEvents.isFirstEvent() ||
    LisaEvents.isBarParty() ||
    LisaEvents.beachEvent() ||
    LisaEvents.cookieEvent() ||
    LisaEvents.helpingInBar() ||
    LisaEvents.meetingElenInPark() ||
    LisaEvents.argumentInBar() ||
    LisaEvents.pubAftermath() ||
    LisaEvents.breakdown() ||
    LisaEvents.conclusion()
    ;
}

LisaEvents.displayHint = () => {
  return LisaEvents.packageTask() ||
    LisaEvents.isFirstEvent() ||
    LisaEvents.isBarParty() ||
    LisaEvents.beachEvent() ||
    LisaEvents.cookieEvent() ||
    LisaEvents.helpingInBar() ||
    LisaEvents.meetingElenInPark() ||
    LisaEvents.argumentInBar() ||
    LisaEvents.pubAftermath() ||
    LisaEvents.breakdown() ||
    LisaEvents.conclusion()
    ;
}

/*
- Something to drink (5$)
- how are you ?
- do you hame time to talk ?
 */
LisaEvents.genericTalk_1 = () => {
  return YsServices.questService.status(YsServices.questService.questEnum.elenPackageQuest) === YsServices.questService.statusEnum.Completed &&
    !LisaEvents.hasActiveEvent();
}

LisaEvents.packageTask = () => {
  return YsServices.questService.status(YsServices.questService.questEnum.elenPackageQuest) === YsServices.questService.statusEnum.Active;
}

LisaEvents.isFirstEvent = () => {
  // czy już drugi rozdział
  if(!EventStateService.secondChapterIntro) {
    return false;
  }

  // czy już odbył się jakiś event z lisą tego dnia
  if(EventStateService.lisaDailyEventChecked) {
    return false;
  }

  //zakończony quest z paczką
  if(YsServices.questService.status(YsServices.questService.questEnum.elenPackageQuest) !== YsServices.questService.statusEnum.Completed) {
    return false;
  }

  return !EventStateService.lisaFirstEvent;
}

LisaEvents.isBarParty = () => {
  // czy już drugi rozdział
  if(!EventStateService.secondChapterIntro) {
    return false;
  }

  // czy już odbył się jakiś event z lisą tego dnia
  if(EventStateService.lisaDailyEventChecked) {
    return false;
  }

  //zakończony quest z paczką
  if(!EventStateService.lisaFirstEvent) {
    return false;
  }

  return !EventStateService.lisaBarParty;
}

LisaEvents.beachEvent = () => {
  // czy odbył się poprzedni event z Elen
  if (!EventStateService.elenMeetingLisa) {
    return false;
  }

  // czy już odbył się jakiś event z lisą tego dnia
  if(EventStateService.lisaDailyEventChecked) {
    return false;
  }

  return !EventStateService.lisaBeachMeeting;
}

LisaEvents.cookieEvent = () => {
  // czy odbył się poprzedni event
  if (!EventStateService.lisaBeachMeeting) {
    return false;
  }

  // czy już odbył się jakiś event z lisą tego dnia
  if(EventStateService.lisaDailyEventChecked) {
    return false;
  }

  return !EventStateService.lisaCookie;
}

LisaEvents.helpingInBar = () => {
  // czy odbył się poprzedni event
  if (!EventStateService.lisaCookie) {
    return false;
  }

  // czy już odbył się jakiś event z lisą tego dnia
  if(EventStateService.lisaDailyEventChecked) {
    return false;
  }

  return !EventStateService.lisaHelpingInBar;
}

LisaEvents.meetingElenInPark = () => {
  // czy odbył się poprzedni event
  if (!EventStateService.lisaHelpingInBar) {
    return false;
  }

  // czy już odbył się jakiś event z lisą tego dnia
  if(EventStateService.lisaDailyEventChecked) {
    return false;
  }

  return !EventStateService.lisaMeetingElenInPark;
}

LisaEvents.argumentInBar = () => {
  if (!EventStateService.lisaMeetingElenInPark) {
    return false;
  }

  // czy już odbył się jakiś event z lisą tego dnia
  if(EventStateService.lisaDailyEventChecked) {
    return false;
  }

  return !EventStateService.lisaArgumentInBar;
}

LisaEvents.pubAftermath = () => {
  // czy już odbył się jakiś event z lisą tego dnia
  if(EventStateService.lisaDailyEventChecked) {
    return false;
  }

  if (!EventStateService.lisaArgumentInBar) {
    return false;
  }

  if (!EventStateService.elenPubAftermath) {
    return false;
  }

  return !EventStateService.lisaPubAftermath;
}

LisaEvents.breakdown = () => {
  // czy już odbył się jakiś event z lisą tego dnia

  if (!EventStateService.elenBeachTrip) {
    return false;
  }

  return !EventStateService.lisaBreakdown;
}

LisaEvents.conclusion = () => {
  // czy już odbył się jakiś event z lisą tego dnia
  if(EventStateService.lisaDailyEventChecked) {
    return false;
  }

  if (!EventStateService.lisaBreakdown) {
    return false;
  }

  return !EventStateService.lisaConclusion;
}
